<template>
  <div class="padding-10px">
    <el-card class="box-card" shadow="none" style="min-height: 500px;">
      <div slot="header" class="clearfix" style="display: flex; flex-direction: column">
        <el-row>
          <el-col :span="6">
            <div>
              <el-input placeholder="请输入搜索关键字" v-model="key" size="medium" style="width: 97%;" clearable>
              </el-input>
            </div>
          </el-col>
          <el-col :span="7">
            <div>
              <el-button type="primary" size="medium" icon="el-icon-search">搜索</el-button>
            </div>
          </el-col>
          <el-col :span="9">
            <div>
              &nbsp;
            </div>
          </el-col>
          <el-col :span="2">
            <el-button type="success" size="medium" @click="linkTo('/front/agreement/add')"
              v-if="checkButtonPermission('front:manage:agreement:add')">新增协议</el-button>
          </el-col>
        </el-row>
      </div>
      <div>
        <el-table :data="tableData" border style="width: 100%" max-height="400">
          <el-table-column prop="title" label="标题"></el-table-column>
          <el-table-column prop="agreementCategory" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.agreementCategory == 0">车贷协议</span>
              <span v-else-if="scope.row.agreementCategory == 1">导购协议</span>
              <span v-else-if="scope.row.agreementCategory == 2">登录注册协议</span>
            </template>
          </el-table-column>
          <el-table-column prop="createTime" label="时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button type="success" size="mini" style="background-color: #7266ba; border-color: #7266ba;"
                v-if="checkButtonPermission('front:manage:agreement:enable')">启用
              </el-button>
              <el-button type="danger" size="mini" v-if="checkButtonPermission('front:manage:agreement:enable')">禁用
              </el-button>
              <el-button @click="editDialog(scope.row)" type="success" size="mini"
                v-if="checkButtonPermission('front:manage:agreement:edit')">编辑
              </el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 18px 0px; float: right;">
          <el-pagination background @current-change="currentPageChange" @size-change="pageSizeChange"
            :current-page="currentPage" :page-sizes="[5, 10, 20, 50, 100]" :page-size="pageSize" :page-count="totalPage"
            layout="total, sizes, prev, pager, next, jumper" :total="total">
          </el-pagination>
        </div>
      </div>
    </el-card>
    <el-dialog title="编辑协议" :modal="false" @close="resetForm('agreementForm')" :visible.sync="dialogVisible"
      :close-on-click-modal="false">
      <el-form :model="agreementForm" ref="agreementForm" label-width="120px" size="medium" style="padding: 0 10%;">
        <el-form-item label="协议名称" prop="title">
          <el-input v-model="agreementForm.title" clearable></el-input>
        </el-form-item>
        <el-form-item label="协议类型" prop="categorySelectVal">
          <el-select v-model="categorySelect" @change="categorySelectChange" placeholder="请选择状态">
            <el-option v-for="item in categoryOptions" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="内容">
          <argeement-edit v-on:listenToChildEvent="showMsgFromEdit"
            :parent-content="agreementForm.agreementContent"></argeement-edit>
        </el-form-item>
        <el-form-item style="padding: 0; margin: 0;">
          <el-button @click="dialogVisible = false">&nbsp;&nbsp;&nbsp;取&nbsp;&nbsp;消&nbsp;&nbsp;&nbsp;</el-button>
          <el-button type="primary"
            @click="submitArgeementForm('agreementForm')">&nbsp;&nbsp;&nbsp;确&nbsp;&nbsp;定&nbsp;&nbsp;&nbsp;</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { reqCode, dialogAction } from '@/common/const';
import argeementEdit from "../../components/plugins/edit/argeementEdit";
export default {
  name: "agreementList",
  components: {
    argeementEdit,
  },
  data() {
    return {
      tableData: [
        {
          title: '张三',
        }
      ],
      currentPage: 1,
      pageSize: 20,
      totalPage: 100,
      total: 100000,
      key: '',
      agreementForm: {
        title: '',
        agreementContent: '',
      },
      dialogVisible: false,
      categorySelect: '',
      categorySelectVal: -1,
      categoryOptions: [
        {
          label: '车贷',
          value: 0,
        },
        {
          label: '导购',
          value: 1,
        },
        {
          label: '登录注册',
          value: 2,
        },
      ]
    }
  },
  created() {
    this.getAgreements();
  },
  methods: {
    getAgreements() {
      let reqParam = {
        key: this.key,
        size: this.pageSize,
        currentPage: this.currentPage,
      };
      this.$http.post('/api/front/agreement/search', reqParam, {
        headers: {
          accessToken: sessionStorage.getItem('accessToken')
        }
      }).then(resp => {
        console.log(resp)
        let status = resp.status;
        if (status == 200) {
          let data = resp.data.data;
          let code = resp.data.code;
          if (reqCode.SUCCESS == code) {
            this.tableData = data.list;
            this.pageSize = data.pageSize;
            this.total = data.total;
            this.totalPage = data.pages;
          }
        }
      }).catch(response => {
        this.$alert('服务器发生异常，请联系开发者，这是错误信息：' + response, '错误提示', {
          confirmButtonText: '确定'
        });
      })
    },
    currentPageChange(val) {
      this.currentPage = val;
    },
    pageSizeChange(val) {
      this.pageSize = val;
    },
    linkTo(url) {
      this.$router.push({ path: url });
    },
    showMsgFromEdit(data) {
      this.agreementForm.agreementContent = data;
    },
    resetForm(formName) {
      this.$nextTick(() => {
        this.agreementForm = {
          agreementContent: `
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                          <br/><br/><br/><br/><br/>
                        `
        };
        this.categorySelect = '';
        this.categorySelectVal = -1;
      })
    },
    checkButtonPermission(perms) {
      let menuPermsList = sessionStorage.getItem("menuPermsList");
      if (menuPermsList.indexOf(perms) != -1) {
        return true
      } else {
        return false;
      }
    },
    categorySelectChange(val) {
      this.categorySelectVal = val;
    },
    submitArgeementForm(formName) {
      let reqParam = {
        agreementId: this.agreementForm.agreementId,
        title: this.agreementForm.title,
        agreementContent: this.agreementForm.agreementContent,
        agreementCategory: parseInt(this.categorySelectVal),
      };
      this.editArgeement(formName, reqParam);
    },
    editArgeement(formName, reqParam) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$http.post('/api/front/agreement/update', reqParam, {
            headers: {
              accessToken: sessionStorage.getItem('accessToken')
            }
          }).then(resp => {
            let data = resp.data;
            if (data.code) {
              this.$message({
                message: '编辑协议成功',
                type: 'success'
              });
              this.dialogVisible = false;
              this.resetForm();
              this.getAgreements();
            } else {
              this.$alert('' + data.message, '错误提示', {
                confirmButtonText: '确定',
              });
            }
          }).catch(e => {
            this.$alert('' + e, '错误提示', {
              confirmButtonText: '确定',
            });
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editDialog(data) {
      let temp = {};
      Object.assign(temp, data);
      console.log(temp);
      this.agreementForm = temp;

      let agreementCategory = temp.agreementCategory;
      if (agreementCategory == 0) {
        this.categorySelect = '车贷';
        this.categorySelectVal = '0';
      } else if (agreementCategory == 1) {
        this.categorySelect = '导购';
        this.categorySelectVal = '1';
      } else if (agreementCategory == 2) {
        this.categorySelect = '登录注册';
        this.categorySelectVal = '2';
      }

      this.dialogVisible = true;
    }
  }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/views/front/agreementList.vue